import { useRouter } from "next/router";
import AnimationHeading from "src/components/AnimationsTags/AnimationHeading/AnimationHeading";
import Image from "next/image";
import Divider from "src/components/Divider/Divider";
import OurPrinciplesLocales, { title as OurPrinciplesTitle } from "./locales/data"

const OurPrinciples = () => {
  const { locale } = useRouter();

  return (
    <section className='px-4'>
      <div className='container mx-auto py-10'>
        <AnimationHeading
          title={OurPrinciplesTitle[locale].title}
          size="text-2xl xl:text-4xl"
          additionalStyle="lg:text-center uppercase"
          margin="text-center mb-8"
        />
        <div className="w-full lg:max-w-[1000px] text-center mx-auto">
          {OurPrinciplesTitle[locale].content_1}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-4 md:gap-y-8 smooth-transition lg:px-32 mt-8 mb-16">
          {OurPrinciplesLocales.map((item) => (
            <div
              key={item[locale].title}
              className="w-full py-4 px-8 flex flex-col"
            >
              <p className="mx-auto">
                <Image
                  src={`/assets/sections/procurement/out_principles/${item.icon}.svg`}
                  alt={`${item.icon} icon`}
                  width={80}
                  height={80}
                  objectFit="contain"
                />
              </p>

              <p className="uppercase font-medium py-0 text-center">
                {item[locale].title}
              </p>
            </div>
          ))}
        </div>
        <Divider>
          {OurPrinciplesTitle[locale].content_2}
        </Divider>
      </div>
    </section>
  );
};

export default OurPrinciples;